/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './EmprestimoGarantiaCarroContratoPassoaPasso.css';
import CustomEmblaCarousel from '../CustomEmblaCarousel/CustomEmblaCarousel';
import RedButton from '../../atoms/RedButton/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function EmprestimoGarantiaCarroContratoPassoaPasso() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <>
      <section id="emp-garantia-contrato-passo-a-passo">
        {/* <img
          className="boleto-logo-santander"
          src="assets/boleto25/Santander.svg"
          alt="logo santander"
        /> */}
        <ContainerHome24 className="ctn-slide">
          <h3 className="emp-garantia-contrato-passo-a-passo-title">
            <b>Confira o passo a passo</b> para gerar a 2ª via do <b>boleto</b> do seu empréstimo
          </h3>
          <div className="emp-garantia-contrato-passo-a-passo-mobile">
            <CustomEmblaCarousel enableBullets bulletCount={width <= 992 ? 5 : 2}>
              {({ className }) => (
                <>
                  <div className={`slide emp-garantia-contrato-passo-a-passo-card ${className}`}>
                    <img
                      className="emp-garantia-contrato-passo-a-passo-card-img"
                      src="assets/boleto25/ic_account_people.svg"
                      alt=""
                    />
                    <p className="emp-garantia-contrato-passo-a-passo-card-text">
                      1. Clique no botão <b>gerar boleto</b> ou acesse o aplicativo{' '}
                      <a
                        href="https://emprestimosim.com.br/app/#/login/signInWithPassword"
                        target="_blank"
                      >
                        Sim | Santander
                      </a>
                      .
                    </p>
                    <div className="separador-slide" />
                  </div>
                  <div className={`slide emp-garantia-contrato-passo-a-passo-card ${className}`}>
                    <img
                      className="emp-garantia-contrato-passo-a-passo-card-img"
                      src="assets/boleto25/ic_document_contract.svg"
                      alt=""
                    />
                    <p className="emp-garantia-contrato-passo-a-passo-card-text">
                      2. Selecionar <b>Meus contratos</b> no menu.
                    </p>
                    <div className="separador-slide" />
                  </div>
                  <div className={`slide emp-garantia-contrato-passo-a-passo-card ${className}`}>
                    <img
                      className="emp-garantia-contrato-passo-a-passo-card-img"
                      src="assets/boleto25/ic_mobile_recharge.svg"
                      alt=""
                    />
                    <p className="emp-garantia-contrato-passo-a-passo-card-text">
                      3. Clique em <b>gerar boletos</b>.
                    </p>
                    <div className="separador-slide" />
                  </div>
                  <div className={`slide emp-garantia-contrato-passo-a-passo-card ${className}`}>
                    <img
                      className="emp-garantia-contrato-passo-a-passo-card-img"
                      src="assets/boleto25/ic_bill_payment.svg"
                      alt=""
                    />
                    <p className="emp-garantia-contrato-passo-a-passo-card-text">
                      4. Selecione a(s) <b>parcelas(s) desejada(s)</b> e clique em pagar.
                    </p>
                    <div className="separador-slide" />
                  </div>
                  <div className={`slide emp-garantia-contrato-passo-a-passo-card ${className}`}>
                    <img
                      className="emp-garantia-contrato-passo-a-passo-card-img"
                      src="assets/boleto25/ic_levy_received.svg"
                      alt=""
                    />
                    <p className="emp-garantia-contrato-passo-a-passo-card-text">
                      5. Pronto! <b>Copie o código de barras ou imprima o PDF</b> para realizar o
                      pagamento.
                    </p>
                  </div>
                </>
              )}
            </CustomEmblaCarousel>
          </div>
          <div className="emp-garantia-contrato-passo-a-passo-desktop">
            <div className={`slide emp-garantia-contrato-passo-a-passo-card`}>
              <img
                className="emp-garantia-contrato-passo-a-passo-card-img"
                src="assets/boleto25/ic_account_people.svg"
                alt=""
              />
              <p className="emp-garantia-contrato-passo-a-passo-card-text">
                1. Clique no botão <b>gerar boleto</b> ou acesse o aplicativo{' '}
                <a
                  href="https://emprestimosim.com.br/app/#/login/signInWithPassword"
                  target="_blank"
                >
                  Sim | Santander
                </a>
                .
              </p>
              <div className="separador-slide" />
            </div>
            <div className={`slide emp-garantia-contrato-passo-a-passo-card`}>
              <img
                className="emp-garantia-contrato-passo-a-passo-card-img"
                src="assets/boleto25/ic_document_contract.svg"
                alt=""
              />
              <p className="emp-garantia-contrato-passo-a-passo-card-text">
                2. Selecionar <b>Meus contratos</b> no menu.
              </p>
              <div className="separador-slide" />
            </div>
            <div className={`slide emp-garantia-contrato-passo-a-passo-card`}>
              <img
                className="emp-garantia-contrato-passo-a-passo-card-img"
                src="assets/boleto25/ic_mobile_recharge.svg"
                alt=""
              />
              <p className="emp-garantia-contrato-passo-a-passo-card-text">
                3. Clique em <b>gerar boletos</b>.
              </p>
              <div className="separador-slide" />
            </div>
            <div className={`slide emp-garantia-contrato-passo-a-passo-card`}>
              <img
                className="emp-garantia-contrato-passo-a-passo-card-img"
                src="assets/boleto25/ic_bill_payment.svg"
                alt=""
              />
              <p className="emp-garantia-contrato-passo-a-passo-card-text">
                4. Selecione a(s) <b>parcelas(s) desejada(s)</b> e clique em pagar.
              </p>
              <div className="separador-slide" />
            </div>
            <div className={`slide emp-garantia-contrato-passo-a-passo-card`}>
              <img
                className="emp-garantia-contrato-passo-a-passo-card-img"
                src="assets/boleto25/ic_levy_received.svg"
                alt=""
              />
              <p className="emp-garantia-contrato-passo-a-passo-card-text">
                5. Pronto! <b>Copie o código de barras ou imprima o PDF</b> para realizar o
                pagamento.
              </p>
            </div>
          </div>
          <RedButton
            href="https://emprestimosim.com.br/app/#/login/signInWithPassword"
            id="passo-a-passo-gerar-boleto"
            wide
            target="_blank"
            rel="noopener"
          >
            Gerar boleto
          </RedButton>
        </ContainerHome24>
      </section>
      <section id="boleto-whats-app-desk">
        <ContainerHome24>
          <div className="whats-app-textos">
            <h3 className="whats-app-titulo">
              Você também pode gerar a 2ª via do seu <b>boleto pelo WhatsApp</b>
            </h3>
            <p className="whats-app-texto">
              Você sabia que é possível gerar seus boletos através do WhatsApp?
              <br />
              Basta <div className="is-desk">ler o QR Code ao lado ou </div>
              <a
                href="https://api.whatsapp.com/send?phone=551140049090&text=Ol%C3%A1%20Santander%20Financiamentos"
                target="_blank"
                rel="noopener"
              >
                acessar seu WhatsApp<div className="is-desk"> Web</div>
              </a>{' '}
              e emitir a 2ª via de forma rápida e fácil.
              <br />
              <br />
              <b>Praticidade e segurança</b> de onde estiver.
            </p>
          </div>
          <img
            src="assets/emprestimo-garantia-carro-contrato/qrcode-whatsapp-santander-emprestimo.jpeg"
            className="whats-app-qrcode"
            alt="qr code do WhatsApp de Boletos Santander"
          />
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroContratoPassoaPasso;
